import { IDENTITY_CONFIG, METADATA_OIDC } from "./authConst";
import { UserManager, WebStorageStateStore, Log } from "oidc-client";
import apiConfig from './apiConfig';

const hostname = window && window.location && window.location.hostname;
const apiURLs = apiConfig.setEnvironmentURLs(hostname);

console.log("apiURLs in authServices",apiURLs);

export default class AuthService {
    UserManager;

    constructor() {
        this.UserManager = new UserManager({
            ...IDENTITY_CONFIG,
            userStore: new WebStorageStateStore({ store: window.localStorage }),
            metadata: {
                ...METADATA_OIDC
            }
        });
        // Logger
        Log.logger = console;
        Log.level = Log.DEBUG;
        this.UserManager.events.addUserLoaded((user) => {
        });
        this.UserManager.events.addSilentRenewError((e) => {    
        });

        this.UserManager.events.addAccessTokenExpired(() => {
            this.logout();
        });
    }

    signinRedirectCallback = () => {
        this.UserManager.signinRedirectCallback().then(() => {
            //code trial tried here
        });
    };


    getUser = async () => {
        const user = await this.UserManager.getUser();
        if (!user) {
            return this.UserManager.signinRedirectCallback();
        }
        return user;
    };

    parseJwt = (token) => {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace("-", "+").replace("_", "/");
        return JSON.parse(window.atob(base64));
    };


    signinRedirect = () => {
        console.log("redirectUri in signinRedirect",window.location.pathname)
        // localStorage.setItem("redirectUri", window.location.pathname);
        this.UserManager.signinRedirect({});
        //code trial tried here - undefined
    };


    navigateToScreen = () => {        
    };


    isAuthenticated = () => {
        //code trial tried here - undefined
        const oidcStorage = JSON.parse(localStorage.getItem(`oidc.user:${apiURLs.authorityOIDC}:${apiURLs.clientID}`));
        return (!!oidcStorage && !!oidcStorage.access_token)
    };

    signinSilent = () => {
        this.UserManager.signinSilent()
            .then((user) => {                
            })
            .catch((err) => {
                console.log(err);
            });
    };
    signinSilentCallback = () => {
        this.UserManager.signinSilentCallback();
    };

    createSigninRequest = () => {
        console.log("inside createSigninRequest func");
        return this.UserManager.createSigninRequest();
    };

    logout = () => {
        this.UserManager.signoutRedirect({
            id_token_hint: localStorage.getItem("id_token")
        });
        this.UserManager.clearStaleState();
    };

    signoutRedirectCallback = () => {
        this.UserManager.signoutRedirectCallback().then(() => {
            localStorage.clear();
        });
        this.UserManager.clearStaleState();
    };
}